import { defineSlotRecipe } from '@chakra-ui/react'

const cloudWhite = 'var(--alto-sem-color-bg-layer1-default)'

export const customTabs = defineSlotRecipe({
  className: 'CustomTabs',
  slots: ['tabWrap', 'tabList', 'tabListButton', 'tabContent'],
  base: {
    tabListButton: {
      borderRadius: '5px 5px 0 0',
      fontWeight: 'medium',
      textTransform: 'none',
      height: 14,
      p: '0px 32px',
    },
    tabWrap: {
      _before: { bgColor: cloudWhite },
      marginLeft: {
        base: '0',
        md: 2,
      },
      marginRight: {
        base: '0',
        md: 2,
      },
    },
    tabContent: {
      backgroundColor: cloudWhite,
      borderRadius: {
        base: '0',
        md: '0 0.625rem 0.625rem 0.625rem',
      },
    },
  },
})
